import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=1cf32457&scoped=true"
import script from "./Players.vue?vue&type=script&lang=js"
export * from "./Players.vue?vue&type=script&lang=js"
import style0 from "./Players.vue?vue&type=style&index=0&id=1cf32457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf32457",
  null
  
)

export default component.exports